/** Chaguanas launch photos: PNGs in /public/launch-main/ (synced from project `launch-main`). */
const LAUNCH_MAIN_FILES = [
  '2O0A7808.png',
  '2O0A7815.png',
  '2O0A7831.png',
  '2O0A7833.png',
  '2O0A7848.png',
  '2O0A7849.png',
  '2O0A7850.png',
  '2O0A8017.png',
  '2O0A8028.png',
  '2O0A8031.png',
  '2O0A8049.png',
  '2O0A8051.png',
  '2O0A8063.png',
  '2O0A8090.png',
  '2O0A8096.png',
  '2O0A8195.png',
  '2O0A8197.png',
  '2O0A8200.png',
  '2O0A8261.png',
  '2O0A8262.png',
  '2O0A8265.png',
  '2O0A8313.png',
  'IMG_0763.png',
  'IMG_0803.png',
  'IMG_7869.png',
];

export const GIDEON_LAUNCH_IMAGES = LAUNCH_MAIN_FILES.map((filename, i) => ({
  src: `/launch-main/${filename}`,
  index: i + 1,
}));
